import {
    Directive, OnInit, OnChanges, OnDestroy, SimpleChanges, HostListener,
    EventEmitter, Output
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { BindingData, BindingList, Change, ChangeType, ViewModel, FrameContext, DataTypeInfo, EntityPathConverter, RunMode, ComponentType, ExpressionUtil, ENABLE_EDIT_STATE_FILTER_SORTING } from '@farris/devkit';
import { DatagridComponent } from '@farris/ui-datagrid';
import { debounceTime, finalize } from 'rxjs/operators';
// tslint:disable: max-line-length

/*
 * ä½¿ç¨ç»å®æ°æ®æä»¤
 */
@Directive({
    selector: '[farris-use-binding-data]'
})
export class FarrisDatagridUseBindingDataDirective implements OnInit, OnChanges, OnDestroy {
    // private _PROPS: { [propName: string]: any };
    // æåºå­æ®µ
    private sortFields: string = null;
    // æåºæ¹å
    private sortDirections: string = null;
    /**
     * æ¯å¦å·²æåº
     */
    private hasSorted = false;
    /**
     * è¿æ»¤æ¡ä»¶
     */
    private filters: any = null;
    // protected get props() {
    //   return this._PROPS;
    // }
    // protected set props(value) {
    //   this._PROPS = value;
    // }
    protected bindingDataChangeEvent: Subscription;
    /**
     * æ¸²ægrid
     */
    private renderGridSubject: Subject<any> = new Subject<any>();
    private enableFilterSorting = false;
    /**
     * éä¸­è¡åæ¢äºä»¶
     */
    @Output() selectedRowChange: EventEmitter<any> = new EventEmitter<any>();
    // private renderGridDebounce;
    constructor(public bindingData: BindingData, public viewModel: ViewModel, public grid: DatagridComponent) {
        this.setChecks([]);
        this.enableFilterSorting = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.injector.get<boolean>(ENABLE_EDIT_STATE_FILTER_SORTING, false) || false;
        this.registerEvent();
    }

    // #region Ng Event

    ngOnInit() {
        const { pageSize = 0 } = this.getPagingInfo() || {};
        if (pageSize !== 0) {
            // å¯ç¨åé¡µ
            if ((!this.grid.pageList || this.grid.pageList.length < 1) && typeof this.grid['setPageList'] === 'function') {
                this.grid['setPageList']([pageSize, pageSize * 2, pageSize * 3, pageSize * 4]);
            }
        }
        this.setComponentRef();
        this.bindData();
        window.setTimeout(() => {
            this.updateSelectedRow();
        }, 0);
        this.registerBindingDataChangeEvent();
        this.renderGridSubject.pipe(debounceTime(500)).subscribe((change: Change) => {
            if (!this.viewModel || !this.viewModel.frameContext || this.viewModel.frameContext.isDisposed) {
                return;
            }
            this.bindData(change);
        });
        if (this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.frameComponent) {
            this.viewModel.frameContext.frameComponent.componentType = ComponentType.farrisDataGridComponent;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.bindData();
    }

    // #endregion


    /**
     * ä¸»é®
     */
    protected get primaryKey() {
        return this.bindingList.primaryKey;
    }
    /**
     * è·åç»å®æ°æ®
     */
    protected get bindingList(): BindingList {
        // æ ¹å®ä½
        if (this.viewModel.bindingPath === '/' || !this.viewModel.bindingPath) {
            return this.bindingData.list;
        }
        // å­å®ä½
        let bindingPath = this.viewModel.bindingPath.substr(1);
        bindingPath = bindingPath[0].toLowerCase() + bindingPath.substring(1, bindingPath.length);
        const paths = bindingPath.split('/');

        const filteredPaths = paths.filter((part: string) => {
            return part !== '';
        });
        return this.bindingData.getValue(filteredPaths);
    }
    /**
     * è®¾ç½®ç»ä»¶å¼ç¨
     */
    private setComponentRef() {
        const appContext = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.getFormAppContext();
        const frameId = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.frameId;
        const id = this.grid && this.grid.id;
        // å¦æframeIdä¸å­å¨æfarris gridæ²¡æidå±æ§ï¼è¯´æä¸ç¬¦åä½¿ç¨åºæ¯
        if (!frameId || !id) {
            return;
        }
        const map = appContext && appContext.componentRefs && appContext.componentRefs.get(frameId) || new Map<string, any>();
        appContext && appContext.componentRefs && appContext.componentRefs.set(frameId, map.set(id, this.grid));
    }
    /**
     * è·ååé¡µä¿¡æ¯
     */
    protected getPagingInfo() {
        const bindingPath = this.viewModel.bindingPath;
        const bindingData = this.viewModel.bindingData;
        const pagingInfo = bindingData && bindingData.pagingInfo || {};
        if (bindingPath === '/') {
            return pagingInfo;
        } else {
            const bindingPaths = bindingPath.substr(1).split('/').filter((item) => !!item && item.length > 0);
            // ä»è¡¨åä»ä»è¡¨åé¡µåæ°æ®æ¯å³èçï¼å ä¸ºä¸åçä»è¡¨è¡æä¸åçä»ä»è¡¨æ°æ®ï¼åé¡µä¿¡æ¯çç»æä¸ºnodeCode_parentId:{åé¡µä¿¡æ¯}ä¸åé¡µä¿¡æ¯æ¯å¹³çº§ç
            // {pagination:{a_pid:{pageSize:2,pageIndex:1},b_pid:{pageSize:2,pageIndex:1}}}
            // ååºå½åè·¯å¾ä¸å®ä½çnodeCode
            let nodeCode = bindingPaths[bindingPaths.length - 1];
            nodeCode = nodeCode.substr(0, nodeCode.length - 1);
            // è·åå½åå®ä½ä¸çº§çä¸»é®
            // const result = pagingInfo[nodeCode] || {};
            // if (result.hasOwnProperty('totalCount')) {
            //   result.total = result.totalCount;
            // }
            // return result;

            const paths = bindingPaths.slice(0, bindingPaths.length - 1);
            const bindingList = bindingData.getValue(paths) as BindingList;
            const { pageSize = 0 } = pagingInfo[`${nodeCode}`] || {};
            // ä¸çº§è¡¨ææ°æ®
            if (bindingList && bindingList.currentId) {
                const key = `${nodeCode}_${bindingList.currentId}`;
                // const key = nodeCode;
                const result = pagingInfo[key] || {};
                if (result.hasOwnProperty('totalCount')) {
                    result.total = result.totalCount;
                }
                // ä¸çº§è¡¨è½ç¶ææ°æ®ï¼ä½ä¸çº§è¡¨å½åè¡çä¸çº§è¡¨å¯è½æ²¡ææ°æ®ï¼è¿å°±å¯¼è´è·åä¸å°åé¡µä¿¡æ¯ï¼æä»¥éè¦å¨è¿ååå¯¹ç»æè¿è¡å¤çï¼å¦ææ²¡æåé¡µä¿¡æ¯çè¯èµ·ç åºè¯¥è¿ååé¡µå¤§å°åå½åé¡µç 
                if (Object.keys(result).length < 1) {
                    result.pageIndex = 1;
                    result.pageSize = pageSize;
                }
                return result;
            } else {
                // ä¸çº§è¡¨æ²¡ææ°æ®ï¼æ­¤æ¶éè¦è·åå½åè¡¨çåé¡µä¿¡æ¯ï¼å¦åé¡µå¤§å°ãå½åé¡µé»è®¤ä¸º1å³å¯ã
                return { pageIndex: 1, pageSize };
            }
        }
    }

    // #region Input
    /**
     * ç»ä»¶æ¯å¦éè¦æ´æ°
     * @param props å½åå±æ§
     * @param nextProps æ°å±æ§
     * @param change åæ´
     */
    protected shouldComponentUpdate(change: Change, data: any,): { result: boolean, props?: any; } {
        const props = this.buildProps(data);
        if (this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.appContext && this.viewModel.frameContext.appContext.runMode === RunMode.highSpeed && change) {
            if (change.type === ChangeType.Load || change.type === ChangeType.Remove || change.type === ChangeType.PaginationInfoChange) {
                return { result: true, props };
            }
        }
        const gridProps = this.buildGridProps();
        if (JSON.stringify(props) === JSON.stringify(gridProps)) {
            return { result: false };
        }
        return { result: true, props };
    }
    protected registerEvent() {
        // æåºäºä»¶
        this.grid && this.grid.columnSorted && this.grid.columnSorted.subscribe((event: any) => {
            const isRemoteSort = this.grid.remoteSort;
            // æ¬å°æåº
            if (!isRemoteSort) {
                this.sortFields = this.grid.sortName;
                this.sortDirections = this.grid.sortOrder;
                this.sortBindingList();
                // this.props = this.buildProps();
            } else {
                // æå¡å¨ç«¯æåº
                const groupField = this.grid && this.grid.groupField || null;
                let sortFields = this.grid.sortName && this.grid.sortName.split(',') || [];
                const sortDirection = this.grid.sortOrder && this.grid.sortOrder.split(',') || [];
                if (groupField) {
                    const groupFields = groupField.split(',').filter((p) => p);
                    groupFields.reverse().forEach((field: string) => {
                        if (!sortFields.includes(field)) {
                            sortFields.splice(0, 0, field);
                            sortDirection.splice(0, 0, 'asc');
                        }
                    });
                }
                // è·åå½åentityä¸ææobjectå±æ§
                const entityType = this.viewModel && this.viewModel.frameContext.repository.entityType || null;

                if (sortFields.length > 0) {
                    if (entityType) {
                        const dataTypeInfo = new DataTypeInfo(entityType);
                        sortFields = sortFields.map(field => {
                            //if (field && field.indexOf('.') !== -1) {
                            const paths = field.split('.');
                            const propInfo = dataTypeInfo.getPropInfoByPath(paths);
                            const originalField = propInfo && propInfo.metadataInfo['path'] || null;
                            return originalField;
                            //}
                            //return field;
                        });
                    }
                }
                // éåå±æ§ï¼æ ¹æ®datafieldè½¬æ¢ä¸ºoriginalDataField
                const fields = sortFields.join(',');
                const directions = sortDirection.join(',') || 'asc';
                const frameContext: FrameContext = this.viewModel && this.viewModel.frameContext || null;
                if (frameContext) {
                    frameContext.repository.sortConditionManager.setConditions(this.viewModel.bindingPath, fields, directions);
                }
            }
        });
        // è¿æ»¤äºä»¶
        this.grid && this.grid.filterChanged && this.grid.filterChanged.subscribe((event: any) => {
            this.filters = event;
            if (!this.grid.remoteFilter) {
                this.bindingList.filter(this.filters);
                if (this.bindingList.length > 0 && !this.bindingList.currentId) {
                    const id = this.bindingList.getIdByIndex(0);
                    this.bindingList.setCurrentId(id);
                }
                this.bindData();
            }
        });
        this.viewModel.frameContext.appContext.messagePipe.subscribe((message) => {
            if (message && message === 'CLEAR_GRID_CONDITION' && this.filters && Object.keys(this.filters).length > 0) {
                this.filters = {};
                this.bindData();
            }
        });
    }

    /**
     * å¯¹bindingListæåº
     * @param change change
     */
    private sortBindingList(change?: Change) {
        // groupFieldå¯è½æå¤ä¸ªï¼ä»¥éå·åéçå­ç¬¦ä¸²
        const groupField = this.grid && this.grid.groupField || null;
        if (groupField) {
            const arrSortFields = this.sortFields && this.sortFields.split(',') || [];
            const groupFields = groupField.split(',').reverse();
            groupFields.forEach((field: string) => {
                if (!arrSortFields.includes(field)) {
                    arrSortFields.splice(0, 0, field);
                    const arrSortDirection = this.sortDirections && this.sortDirections.split(',') || [];
                    arrSortDirection.splice(0, 0, 'asc');
                    this.sortFields = arrSortFields.join(',');
                    this.sortDirections = arrSortDirection.join(',') || 'asc';
                }
            });
        }
        this.bindingList.sortBy(this.sortFields, this.sortDirections);
        this.bindData(change);
    }
    // #endregion

    // #region æ°æ®ç»å®é¨å
    /**
     * æ´æ°æ°æ®
     * @param change? åæ´
     */
    bindData(change?: Change) {
        const isRemoteFilter = this.grid && this.grid.remoteFilter || false;
        // åæ§è¡æåº
        const shouldSort = this.shouldSort(change);
        if (shouldSort) {
            this.hasSorted = true;
            this.sortBindingList(change);
            return;
        }
        this.hasSorted = false;
        // æ°å¢æ°æ®æ¶æ¸ç©ºè¡¨æ ¼ç­éæ¡ä»¶
        if ((this.grid.editable === true || change && change.type === ChangeType.Append) && this.filters && Object.keys(this.filters).length > 0 && !isRemoteFilter) {
            if (!this.viewModel.frameContext.appContext.enableGridHeaderWhenEditing && !this.enableFilterSorting) {
                this.filters = {};
                this.grid.clearCondition();
            }
        }
        const shouldFiltering = this.shouldFiltering(change);
        if (shouldFiltering) {
            this.bindingList.filter(this.filters);
        }
        // åtoJSON
        const data: any = this.bindingList.toJSON();
        // if (this.filters && Object.keys(this.filters).length > 0 && !isRemoteFilter) {
        //   // data = this.grid.clientFilterService.executeFilter(data, this.filters);
        // }

        if (this.filters && Object.keys(this.filters).length > 0 && !isRemoteFilter && (!change || change && change.type !== ChangeType.SelectionChanged && change.type !== ChangeType.GlobalSelectionChanged)) {
            if (data && data.length > 0) {
                // å¤æ­å½åè¡æ¯å¦å¨è¿æ»¤åçæ°æ®ä¸­
                const row = (data as []).find((item) => item[this.bindingList.primaryKey] === this.bindingList.currentId);
                if (!row) {
                    const firstRowId = data[0][this.bindingList.primaryKey];
                    this.bindingList.setCurrentId(firstRowId, true, true);
                }
            } else {
                // æ¬å°è¿æ»¤å®ä¹åæ²¡ææ°æ®äº
                // this.bindingList.currentId = null;
                if (this.bindingList.currentId) {
                    this.bindingList.setCurrentId(null, true, true, true);
                }
                // åéæ¶æ¸ç©ºids
                if (!this.grid.multiSelect) {
                    this.setChecks([]);
                }
            }
        }
        const result = this.shouldComponentUpdate(change, data);
        if (!result.result) {
            return;
        }
        // const nextProps = this.buildProps(result);
        this.renderGrid(result.props);
        // this.props = JSON.parse(JSON.stringify(result.props));
    }
    /**
     * æ¯å¦åºè¯¥è¿æ»¤
     * @param change - change
     * @returns {boolean}
     */
    private shouldFiltering(change?: Change) {
        const isRemoteFilter = this.grid && this.grid.remoteFilter || false;
        // å¯ç¨è¿ç«¯è¿æ»¤æ¶ä¸éè¦æ¬å°è¿æ»¤
        if (isRemoteFilter === true) {
            return false;
        }
        // æ²¡æè¿æ»¤æ¡ä»¶æ¶ä¸éè¦æ§è¡è¿æ»¤
        if (!this.filters || Object.keys(this.filters).length < 1) {
            return false;
        }
        if (change) {
            return change.type === ChangeType.Load;
        }
        return !this.grid.editable;
    }
    private shouldSort(change?: Change) {
        // this.sortFields && !this.grid.editable && change && (change.type === 'Load' || change.type === 'SelectionChanged')
        if ((!this.sortFields || Object.keys(this.sortFields).length < 1) && !this.grid.groupField) {
            return false;
        }
        if (this.hasSorted) {
            return false;
        }
        if (change) {
            return change.type === 'Load' || change.type === 'SelectionChanged';
        }
        if (this.grid.groupField) {
            return true;
        }
        return this.grid.editable;
    }
    /**
     * æ¸²ægrid
     * @param props å±æ§
     */
    private renderGrid(props: any) {
        const { pageIndex, pageSize, total, pagination, data } = props;
        const virtualizedLoad = this.grid.virtualizedAsyncLoad || false;
        this.grid.total = total;
        this.grid.pageSize = pageSize;
        this.grid.pageIndex = pageIndex;
        this.grid.pagination = pagination;
        this.grid.controlPaginationState = false;
        // this.endCellEdit();
        if (pageSize === 0) {
            this.grid.pagination = false;
            this.grid.pageIndex = 1;
            // ä¿®å¤ä¸åé¡µæ¶gridå¯ç¨åç»ä»ä¼éæ°é¦æ°çé®é¢
            // this.grid.pageSize = total;
        }
        if (virtualizedLoad) {
            this.grid.loadVirtualData({
                items: data,
                pageIndex,
                pageSize,
                total
            });
        } else {
            this.grid.loadData(data);
        }
    }
    /**
     * æé è¡¨æ ¼æ°æ®å±æ§
     */
    protected buildProps(datas?: Array<any>) {
        let data;
        if (typeof (datas) !== 'undefined') {
            data = datas;
        } else {
            data = this.bindingList.toJSON();
        }
        const { pageIndex = 1, pageSize = 0 } = this.getPagingInfo() || {};
        let { total = 0 } = this.getPagingInfo() || {};
        if (pageSize === 0 && total === 0) {
            total = data.length;
        }
        return { data, pageIndex, pageSize, total, pagination: pageSize !== 0 };
    }
    /**
     * è®¡ç®gridç¶æ
     */
    private buildGridProps() {
        const data = this.grid.data || [];
        const { pageIndex = 1, pageSize = 0 } = { pageIndex: this.grid.pageIndex, pageSize: this.grid.pageSize };
        let total = this.grid.total || 0;
        if (pageSize === 0 && total === 0) {
            total = data.length;
        }
        return { data, pageIndex, pageSize, total, pagination: this.grid.pagination };
    }
    /**
     * æ°æ®æºåçåæ´
     * @param change åæ´
     */
    protected onBindingDataChange(change: Change) {
        this.updateDataSource(change);
        this.updateSelectedRow(change);
        // this.updateGrid(change);
        // ä¸æ¸é¤å¾éè¡ï¼éè¦ä¿çå¾éç¶æ
        // this.clearCheckedRows(change);
        this.endCellEdit(change);
        // æ´æ°å¾éè¡æ°æ®
        this.updateCheckedRows(change);
        this.updateData(change);
    }
    /**
     * æ´æ°æ°æ®
     */
    private updateDataSource(change: Change) {
        if (change && change.type === ChangeType.ValueChanged) {
            // è®¡ç®åæ´è·¯å¾ä¸­è¡¨ååå­æ®µå
            const paths = change.path;
            try {
                const entityPath = ExpressionUtil.getAvailableChildrenPathsFromEntityPaths(paths, this.viewModel.frameContext.repository.entityTypeInfo);
                if (this.viewModel.bindingPath === '/' + entityPath.join('/')) {
                    const propertyNames = paths.slice(entityPath.length);
                    if (change.id && this.grid && change.path && this.viewModel.frameContext.appContext.runMode !== RunMode.highSpeed && propertyNames && propertyNames.length > 0) {
                        this.grid.updateRow(change.id, { [propertyNames.join('.')]: change.value });
                    }
                }
            } catch (error) {
                console.warn(error);
            }
            this.renderGridSubject.next(change);
        } else if (change && (change.type === ChangeType.SelectionChanged || change.type === ChangeType.GlobalSelectionChanged)) {
            this.bindData(change);
        } else {
            this.bindData(change);
        }
    }
    // private endCellEdit() {
    //   const isEditing = this.grid.isEditing();
    //   if (isEditing) {
    //     this.grid.endCellEdit();
    //   }
    // }
    private endCellEdit(change: Change) {
        const isEditing = this.grid.isEditing();
        if (change.type === ChangeType.Load && isEditing) {
            this.grid.endCellEdit();
        }
    }
    /**
     * è®¾ç½®gridå½åéæ©è¡
     * @param change åæ´
     */
    private updateSelectedRow(change?: Change) {
        if (!this.bindingList || !this.bindingList.currentId) {
            return;
        }
        // é¡µç åæ¢æ¶ä¸æ§è¡å½åè¡åæ¢
        if (change && change.type === ChangeType.PaginationInfoChange) {
            return;
        }
        if (this.viewModel && this.viewModel.frameContext.bindingData.rowSelectedEventSuspend === true) {
            return;
        }
        const { id: gridSelectedRowId = null } = this.grid.selectedRow || {};
        const currentId = this.bindingList.currentId;
        // gridå½åè¡ä¸bingingListå½åè¡ä¸è´ï¼æ é¡»åæ¢
        if (gridSelectedRowId === currentId) {
            const isMatch = change && (change.path.toString() === this.viewModel.bindingPath.split('/').filter(p => p).toString());
            if (change && change.type === ChangeType.Load && isMatch) {
                this.grid.clearSelections();
                this.grid.selectRow(currentId, true, true);
            }
            return;
        }
        this.selectGridRow(this.bindingList.currentId);
    }
    /**
     * æ³¨åbindingdataååäºä»¶
     */
    private registerBindingDataChangeEvent() {
        this.bindingDataChangeEvent = this.bindingData.changes.subscribe((change: Change) => {
            this.onBindingDataChange(change);
        });
        this.viewModel.frameContext.appContext.messagePipe.subscribe(message => {
            if (message === 'bindData') {
                this.bindData();
            }
        });
    }
    /**
     * åæ¶bindingdataååè®¢é
     */
    private unRegisterBindingDataChangeEvent() {
        if (this.bindingDataChangeEvent && typeof (this.bindingDataChangeEvent.unsubscribe) === 'function') {
            this.bindingDataChangeEvent.unsubscribe();
        }
    }
    /**
     * è§¦åé¡µç åæ¢äºä»¶
     * @description æ¬æ¹æ³éç¨åºæ¯ä»ä¸ºç¶çº§gridæ°æ®éæ°loadï¼éè¦è§¦åè¯¥gridéæ°åæ°ä½¿ç¨ãå¶ä»åºæ¯è¯·å¿ä½¿ç¨
     * @TODO: å¾éæï¼æ§å¶ä¸çº§æ°æ®å è½½åºè¯¥ä¾èµè¡¨æ ¼çè¡åæ¢äºä»¶ï¼ä¸´æ¶è¿æ ·å¤çï¼åç»­æä¾LoadChildrenäºä»¶
     */
    private updateData(change?: Change) {
        if (!(change && (change.type === ChangeType.SelectionChanged || change.type === ChangeType.Load))) {
            return;
        }
        const bindingPath = this.viewModel.bindingPath;
        const eventBindingPath = '/' + change.path.join('/');
        const isRetrieve = this.viewModel.frameContext.appContext.params.get('retrieveing') || false;
        if (change.path.length < 1 || bindingPath === '/' || bindingPath === eventBindingPath || !bindingPath.startsWith(eventBindingPath)) {
            return;
        }
        // retrieveæ¶ä¼èªå¨å¸¦åä»è¡¨ç¬¬ä¸é¡µåä»è¡¨ç¬¬ä¸è¡çä»ä»è¡¨æ°æ®ï¼æä»¥ä¸éè¦åå»åç¬è¯·æ±
        if (isRetrieve) {
            return;
        }
        const fullPaths = EntityPathConverter.toEntityPathArray(this.viewModel.bindingPath, this.bindingData);
        const paths = fullPaths.slice(0, fullPaths.length - 1);
        const parent = this.bindingList.parent;
        const parentId = parent && parent[parent.primaryKey];
        // ä¸çº§è¡¨æ²¡ææ°æ®
        if (!parentId) {
            return;
        }
        // è·ånodecode
        const bindingPaths = this.viewModel.bindingPath.split('/').filter(item => item);
        let nodeCode = bindingPaths[bindingPaths.length - 1];
        nodeCode = nodeCode.substr(0, nodeCode.length - 1);
        // const configPath = `/${nodeCode}_${parentId}`;
        const configPath = `/${nodeCode}`;
        let { pageIndex = 1 } = this.viewModel.frameContext.repository.entityCollection.getPaginationConfigByPath(configPath) || {};
        const { pageSize = 0 } = this.viewModel.frameContext.repository.entityCollection.getPaginationConfigByPath(configPath) || {};

        const parentNodeCode = change.path[change.path.length - 1];
        const parentConfigPath = '/' + parentNodeCode.substring(0, parentNodeCode.length - 1);
        const { pageSize: parentPageSize = 0 } = this.viewModel.frameContext.repository.entityCollection.getPaginationConfigByPath(parentConfigPath) || {};
        const isQueryChild = this.viewModel.frameContext.appContext.params.get('queryChild') || false;
        if (isQueryChild) {
            // this.viewModel.frameContext.appContext.params.delete('queryChild');
            pageIndex = 1;
        }
        // å½ä¸çº§è¡¨åæ¢è¡æ¶
        if (parentPageSize + pageSize !== 0) {
            this.viewModel.frameContext.appContext.params.set('forceQueryChild', true);
            this.viewModel.frameContext.repository.queryChild(paths, pageIndex, pageSize).pipe(
                finalize(() => this.viewModel.frameContext.appContext.params.delete('forceQueryChild'))
            ).subscribe();
        }
    }
    ngOnDestroy() {
        this.unRegisterBindingDataChangeEvent();
    }
    // #endregion

    // #region äºä»¶åå°å¨

    /**
     * åå°éä¸­è¡åæ¢äºä»¶
     * @description ç»ä¸åéæ¨¡å¼åå¤éæ¨¡å¼ä¸çè¡åæ¢äºä»¶
     */
    protected fireSelectedRowChange(selectedRowContext: any) {
        this.selectedRowChange.emit(selectedRowContext);
    }
    /**
     * æ¸ç©ºéå®è¡
     * @param change åæ´
     */
    private clearCheckedRows(change: Change) {
        if (change.type === ChangeType.Load && this.grid.multiSelect) {
            const isMatch = this.checkIfChangeMatchBindingPath(change);
            if (isMatch) {
                this.setChecks([]);
                if (typeof (this.grid.clearCheckeds) === 'function') {
                    this.grid.clearCheckeds();
                }
            }
        }
    }

    // #endregion



    // #region éä¿¡

    /**
     * è®¾ç½®BindingListçå½åè¡
     * @param id å½åè¡åç 
     */
    protected setSelectionIdToBindingData(id: string): void {
        // å¦æå½åè¡ä¸å­å¨ï¼åå¼ºå¶è®¾ç½®
        if (!id) {
            this.bindingList.currentId = id;
            if (!this.grid.multiSelect) {
                this.setChecks([]);
            }
            return;
        }
        if (this.bindingList.currentId !== id) {
            this.bindingList.setCurrentId(id, true);
        }
        // åéæ¨¡å¼ä¸å°å½åè¡è®¾ç½®å°ids
        if (!this.grid.multiSelect) {
            this.setChecks([id]);
        }
    }
    private updateCheckedRows(changes: Change) {
        if (changes.type === ChangeType.Load) {
            this.setCheckedRows();
        } else if (changes.type === ChangeType.ValueChanged) {
            const ids = this.getChecks();
            if (changes.id && ids.includes(changes.id)) {
                this.setCheckedRows();
            }
        }
    }
    /**
     * è®¾ç½®éæ©è¡
     */
    protected setChecks(ids: string[]) {
        this.viewModel.uiState.setPropertyValue('ids', ids);
        this.setCheckedRows(ids);
    }
    /**
     * è·åå¾éè¡idæ°ç»
     * @returns
     */
    protected getChecks(): string[] {
        return this.viewModel.uiState['ids'] || [];
    }
    /**
     * æ´æ°å¾éè¡æ°æ®
     */
    protected setCheckedRows(ids?: string[]) {
        if (this.viewModel.frameContext.appContext.persistSelectedRows === false) {
            return;
        }
        // é«éæ¨¡å¼æ¶ä¸åè®¾ç½®rows
        // if (this.viewModel.frameContext.appContext.runMode === RunMode.highSpeed) {
        //   return;
        // }
        if (typeof ids === 'undefined') {
            ids = this.viewModel.uiState['ids'] || [];
        }
        if (!Array.isArray(ids) || ids.length < 1) {
            // æ­¤æ¶idsæ²¡æå¼ï¼rowsä¸­ä¹ä¸åºè¯¥æ
            this.viewModel.uiState.setPropertyValue('rows', null);
            return;
        }
        let list = [];
        // TODOï¼rowsä¸­æ°æ®å¨é«éæ¨¡å¼åæ®éæ¨¡å¼ä¸å¤è¯­å­æ®µçå¼è¡¨ç°ä¸ä¸è´ï¼é«éæ¨¡å¼ä¸å¤è¯­å­æ®µå¼ä¸ºå¯¹è±¡ï¼æ®éæ¨¡å¼ä¸ºå½åè¯­è¨ãæä¸å¤çé«éæ¨¡å¼åºæ¯
        if (this.viewModel.frameContext.appContext.runMode === RunMode.highSpeed) {
            list = this.grid.data || [];
        } else {
            list = this.bindingList.toJSON({ ignoreMultiLangInput: true });
        }
        const rows: Map<string, any> = this.viewModel.uiState['rows'] || new Map<string, any>();

        const result = new Map<string, any>();
        ids.forEach((id: any) => {
            const item = list.find(item => item[this.primaryKey] === id);
            const otherPageItem = rows.get(id);
            if (item) {
                result.set(id, item);
            } else if (otherPageItem) {
                result.set(id, otherPageItem);
            }
        });
        this.viewModel.uiState.setPropertyValue('rows', result);
    }
    /**
     * éä¸­gridè¡
     * @param id id
     */
    protected selectGridRow(id: any) {
        this.grid.selectRow(id);
        this.grid.scrollToCurrentRow();
    }
    // #endregion
    // #region äºä»¶å¤çå¨

    /**
     * é¡µç åæ¢äºä»¶
     * @param event event
     */
    @HostListener('pageChanged', ['$event'])
    public pageChangedHandler(event: any) {
        let { pageIndex, pageSize } = event;
        if (pageIndex < 1) {
            pageIndex = 1;
        }
        const skip = (pageIndex - 1) * pageSize;
        this.bindingData.setPagingInfo(skip, pageSize, this.bindingData.bindingPath);
    }

    /**
     * è¡åæ¢äºä»¶
     * @param event event
     */
    @HostListener('selectChanged', ['$event'])
    public selectedRowChanged(event: any) {
        const { index, data } = event;
        const id = data[this.primaryKey];
        this.setSelectionIdToBindingData(id);
        this.fireSelectedRowChange(event);
    }

    /**
     * åæ¶è¡éæ©äºä»¶
     * @param event event
     */
    @HostListener('unSelect', ['$event'])
    public unSelected(event: any) {
        if (!event) {
            return;
        }
        const { data = {} } = event;
        const id = data[this.primaryKey];
        const currentId = this.bindingList.currentId;
        if (id === currentId) {
            this.setSelectionIdToBindingData(null);
        }
        // this.fireSelectedRowChange(event);
    }
    /**
     * å¾éè¡åçåå
     * @param event event
     */
    @HostListener('checkedChange', ['$event'])
    public checkedChanged(event: any) {
        event = event || [];
        const ids = event.map(item => item.id);
        this.setChecks(ids);
    }
    /**
     * åé¡µå¤§å°åæ´äºä»¶
     * @param event event
     */
    @HostListener('pageSizeChanged', ['$event'])
    public pageSizeChanged(event: any) {
        const { pageIndex, pageSize } = event;
        const skip = 0;//(pageIndex - 1) * pageSize;
        // this.bindingList.setPaginationInfo(skip, pageSize);
        this.bindingData.setPagingInfo(skip, pageSize, this.bindingData.bindingPath);
    }

    /**
     * gridæ»å¨å è½½æ°æ®
     * @param event event
     */
    @HostListener('scrollYLoad', ['$event'])
    public scrollY(event: any) {
        const { pager: pageIndex, pageSize } = event;
        const skip = (pageIndex - 1) * pageSize;
        this.bindingData.setPagingInfo(skip, pageSize, this.bindingData.bindingPath);
    }
    @HostListener('filterChanged', ['$event'])
    public filterChanged(event: any) {
        this.filters = event;
    }
    // #endregion
    private checkIfChangeMatchBindingPath(change: Change): boolean {
        let isMatch = false;
        if (!change || !change.path) {
            return isMatch;
        }

        const changePathArray = change.path;
        if (!changePathArray) {
            return isMatch;
        }

        if (!(this.bindingData) && !(this.bindingData.bindingPath)) {
            return isMatch;
        }
        const bingdingPathArray = this.bindingData.bindingPath.split('/');
        if (bingdingPathArray.length <= 0) {
            return isMatch;
        }

        if (changePathArray.length === 0) { // ä¸»è¡¨
            if (this.bindingData.bindingPath === '/') {
                isMatch = true;
            }
        } else if (change.path.length === 1) {// ä¸»ä»è¡¨
            if (bingdingPathArray.length === 2 && bingdingPathArray[1] === change.path[0]) {
                isMatch = true;
            }
        } else if (change.path.length === 2) { // ä¸»ä»ä»è¡¨
            if (bingdingPathArray.length === 3 && bingdingPathArray[1] === change.path[0] && bingdingPathArray[2] === change.path[1]) {
                isMatch = true;
            }
        }

        return isMatch;
    }
    private debounce(callback: (...args) => any, wait) {
        let timeoutId = null;
        return (...args) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                callback.apply(null, args);
            }, wait);
        };
    }
}
